/**
 * ScrollToTop — resets window scroll to (0, 0) on every navigation.
 *
 * Without this, react-router keeps the previous page's scroll position
 * when you navigate to a new route, which creates the impression that
 * the new page is "broken" (you land deep down on a page you've never
 * seen). Standard SPA pattern; placed once inside <BrowserRouter>.
 *
 * Skips:
 * - hash-only changes (#section anchors)
 * - same-pathname query-only changes (e.g. /feed?type=video → /feed?type=image)
 *   so filter chips don't whip the user back to the top mid-scroll.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const lastPath = useRef(location.pathname);
  useEffect(() => {
    if (location.hash) return;
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    // Use scrollTo on documentElement + body so iOS Safari also resets
    // when the body has position: fixed locked (e.g. coming back from
    // /kort).
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname, location.hash]);
  return null;
}
